import { ref } from '@vue/composition-api'
import store from '@/store'

export default function useWorkplaceCanAdvance(refetchData) {
  const loading = ref(false)
  const canAdvanceModal = ref(null)

  const workplaceCanAdvance = ref({
    can_advanced_end_date_until: '',
    is_show_date: null,
    workplace_name: null,
    workplace_id: null,
    can_advance: true,
  })

  function show(workplace, canAdvance) {
    workplaceCanAdvance.value.is_show_date = canAdvance ? false : null
    workplaceCanAdvance.value.can_advanced_end_date_until = ''
    workplaceCanAdvance.value.workplace_id = workplace.id
    workplaceCanAdvance.value.workplace_name = workplace.name
    workplaceCanAdvance.value.can_advance = canAdvance
    canAdvanceModal.value.show()
  }

  function continueCanAdvance(isShowDate) {
    workplaceCanAdvance.value.is_show_date = isShowDate
  }

  function editCanAdvance() {
    loading.value = true
    const payload = workplaceCanAdvance.value
    store.dispatch('app-institution/editCanAdvance', payload)
      .then(() => {
        workplaceCanAdvance.value.is_show_date = null
        refetchData()
        loading.value = false
        canAdvanceModal.value.hide()
      }).catch(() => {
        workplaceCanAdvance.value.is_show_date = null
        loading.value = false
      })
  }

  return {
    loading,
    canAdvanceModal,
    workplaceCanAdvance,
    show,
    continueCanAdvance,
    editCanAdvance,
  }
}
